import { render, staticRenderFns } from "./PeriodeHinder.vue?vue&type=template&id=6dacfaf3"
import script from "./PeriodeHinder.vue?vue&type=script&lang=js"
export * from "./PeriodeHinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports